<template>
    <div>
        <div class="col-12 mb-4 d-flex justify-content-between align-items-baseline">
            <h4>Treatment categories</h4>
            <button @click="newTreatmentCategory"
                    :disabled="loading"
                    class="btn btn-primary">
                New treatment category
            </button>
        </div>
        <VueGoodTable :columns="columns"
                      :rows="treatmentCategories"
                      @on-row-click="viewTreatmentCategory"
                      :pagination-options="{
                        enabled: true,
                      }"
                      :isLoading.sync="loading"
                      styleClass="vgt-table condensed"
                      class="vgt-table--card"/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { VueGoodTable } from 'vue-good-table';

export default {
  components: {
    VueGoodTable,
  },
  computed: {
    ...mapGetters({
      treatmentCategories: 'treatmentCategories/treatmentCategories',
    }),
  },
  data() {
    return {
      loading: false,
      columns: [],
    };
  },
  mounted() {
    this.columns = [
      {
        label: 'Name',
        field: 'name',
        filterOptions: {
          enabled: true,
        },
      },
    ];
    this.getTreatmentCategories();
  },
  methods: {
    newTreatmentCategory() {
      this.$router.push({
        name: 'treatment-category',
        params: { id: 'new' },
      });
    },
    getTreatmentCategories() {
      this.loading = true;

      this.$store.dispatch('treatmentCategories/getTreatmentCategories')
        .finally(() => {
          this.loading = false;
        });
    },
    viewTreatmentCategory(event) {
      this.$router.push({
        name: 'treatment-category',
        params: { id: event.row.id },
      });
    },
    updateParams(props) {
      this.$store.commit('treatmentCategories/queryProps', props);
    },
  },
};
</script>
